<header>
  <div class="row no-gutter app-header px-3">
    <div class="col-10 p-0">
      <div class="logo">
        <div class="logo-img">
          <img src="/assets/images/logo_2.png" alt="logo" class="img-responsive" style="height: 35px; width: 170px;" />
        </div>
      </div>
    </div>
    <!-- <div class="col-sm-6 header-menu text-left" *ngIf="breadCrumbs">
                    <div class="user-name cursor" [routerLink]="['/visitors-list']"
                        routerLinkActive="router-link-active">
                        <img class="breadcrumbs" src="../../../assets/images/back.png" alt="" />
                        Back to Registers
                        <div class="clearfix"></div>
                    </div>
                </div> -->
    <div class="header-menu col-2">
      <ul>
        <li class="dropdown">
          <a href="jaavscript:void(0)" class="dropdown-toggle" id="dropdown" data-bs-toggle="dropdown"
          aria-expanded="false">
            <span class="link-text">Hi {{name}}
              <i class="caret"></i>
            </span>
          </a>
          <ul class="dropdown-menu" aria-labelledby="dropdown">
            <li>
              <a class="dropdown-item" (click)="logout();">Logout</a>
            </li>
          </ul>
        </li>
      </ul>
      <div class="clearfix"></div>
    </div>
  </div>
</header>